import useStore from './_store';
import { mapState, mapActions } from '@/store/helpers';

import searchBarMixin, { SEARCH_CHANGE_TYPE } from '@/mixins/search-bar';
// import vuexModule from './_store';

import * as TYPES from './_store/types';
import { recentListingStatus } from './_config';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
// import soldListingInfo from "./mock";

import { normal } from '../defaultSpacing';
import util from '@/common/util';

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-listing-list'
    },
    provide() {
        return {
            normalizedFilter: this.normalizedFilter
        }
    },
    mixins: [searchBarMixin],
    asyncData: mapAsyncData(asyncData),
    watch: {
        hasLocation: {
            handler(val) {
                this.setHasLocation({ data: val });
            },
            immediate: true
        }
    },
    afterAsyncData() {
        this.$nextTick(() => {
            this.watchCondition()
        })
    },
    // vuexModule,
    data: function() {
        return {
            presetFilters: null,
            presetFiltersV2: {},
            ...normal,
            soldListingInfo: null, //  If on the sold details page ， Then the search criteria is the current property's city/zipcode
        };
    },
    computed: {

        ...mapState({
            "listingStatus": store => store.listingStatus,
            "currentListingStatus": store => store.currentListingStatus,
            "fetchListingStatus": store => store.fetchListingStatus,
            "hasFetchListingStatus": store => store.hasFetchListingStatus,
            "listingParams": "listingParams",
            "showRecentListingNoData": "showRecentListingNoData",
            "showThisModule": "showThisModule"
        }),
        
        
        cmpRecentListingTitle() {
            return (
                this.recentListingTitle ??
                this.$t('md-listing-list.recentListings')
            );
        }
    },
    methods: {

        ...mapActions({
            "getListingStatus": TYPES.GET_LISTING_STATUS,
            "getListing": TYPES.GET_LISTING,
            "setCurrentListingStatus": TYPES.SET_CURRENT_LISTING_STATUS,
            "setCurrentListingName": TYPES.SET_CURRENT_LISTING_NAME,
            "setFetchListingStatus": TYPES.SET_FETCH_LISTING_STATUS,
            "setCurrentPage": TYPES.SET_PAGE_NUM,
            "setSearchParams": TYPES.SET_SEARCH_PARAMS,
            "setHasLocation": TYPES.SET_HAS_LOCATION,
        }),
        
        watchConditionNoReq() {
            this[SEARCH_CHANGE_TYPE] = condition => {
                if (this.hasLocation) {
                    this.setSearchParams(condition);
                }
            };
        },
        watchCondition() {
            this[SEARCH_CHANGE_TYPE] = condition => {
                this.onConditionChange(condition);
            };
        },
        onConditionChange(condition) {
            if (this.hasLocation) {
                this.setSearchParams(condition);
            }
            if (util.isSSRServer) {
                return;
            }
            if (this.hasFetchListingStatus) {
                this.fetchListingData({ timeline: true });
            }
        },
        //  set current listing  status
        setListingStatus() {
            const listingStatus = this.listingStatus[0];
            if (!listingStatus) {
                return; 
            }
            this.setCurrentListingStatus({
                data: listingStatus.id
            });
            this.setCurrentListingName({
                data: listingStatus.name
            });
        },
        //  Obtain  recent listing  The data 
        async fetchListingData(extraParams = {}) {
            this.setFetchStatus(); //  set state first 
            this.setCurrentPage({ data: 1 }); //  paged as 1
            //  no choice location  And not on the sold details page   no request data 
            if (!this.hasLocation && !this.soldListingInfo) {
                return; 
            }
            const params = {
                ...this.listingParams,
                ...extraParams
            };
            try {
                // called in asyncData.js
                await this.getListing({ data: params });
                this.setFetchStatus(recentListingStatus.loaded);
                return Promise.resolve();
            } catch (err) {
                // TODO  exception handling 
                throw err;
            }
        },
        //  set up recent listing The state the module is in 
        async setFetchStatus(status) {
            if (status) {
                return this.setFetchListingStatus({ data: status }); 
            }
            if (!this.hasLocation) {
                status = recentListingStatus.noLocation; // no location
            } else {
                if (this.fetchListingStatus === recentListingStatus.coming) {
                    status = recentListingStatus.coming; // coming soon
                } else {
                    status = recentListingStatus.loading; // loading
                }
            }
            this.setFetchListingStatus({ data: status });
        },
       
    }
};
